<template>
  <v-card v-if="desktopPaywallNudgeBannerDisplayed" class="app-card">
    <v-card-text>
      <div class="d-flex justify-space-between align-center mb-2">
        <div class="font-weight-bold font-size-big mr-6">{{ configuration.subscriptionNudges.web_desktop_sidebar.title }}</div>
        <the-button icon small custom-colors class="corner-button color-post-detail" @click="setDesktopPaywallNudgeBannerPromptSkipDate">
          <i-custom-close class="size-3" />
        </the-button>
      </div>
      <div class="mb-4">{{ configuration.subscriptionNudges.web_desktop_sidebar.subtitle }}</div>
      <the-button small block class="my-0" @click="onClick">{{ configuration.subscriptionNudges.web_desktop_sidebar.button_label }}</the-button>
    </v-card-text>
  </v-card>
</template>

<script>
import * as analytics from "@/services/analytics.js"
import * as paywallService from "@/services/paywallService.js"
import { paywallSourceTypes } from "@/constants/paywall.js"

import { mapGetters, mapActions } from "pinia"

import { useAppStateStore } from "@/store/appState.js"
import { useUserSessionStore } from "@/store/userSession.js"
import { useConfigurationStore } from "@/store/configuration.js"

import { parseISO, differenceInWeeks } from "date-fns"

import { intervalPeriods } from "@/constants/paywall.js"

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters(useAppStateStore, ["desktopPaywallNudgeBannerPromptSkipDate"]),
    ...mapGetters(useUserSessionStore, ["ownedPaywallPlan", "paywallData"]),
    ...mapGetters(useConfigurationStore, ["configuration"]),
    desktopPaywallNudgeBannerDisplayed() {
      return (
        this.anyValidWebSubscriptionPresent &&
        this.configuration.subscriptionNudges.web_desktop_sidebar?.enabled &&
        !this.ownedPaywallPlan &&
        ![this.$routes.POST, this.$routes.COMMENT, this.$routes.ARTICLE, this.$routes.LIVE, this.$routes.RTMP].includes(this.$route.name) &&
        (!this.desktopPaywallNudgeBannerPromptSkipDate || differenceInWeeks(new Date(), parseISO(this.desktopPaywallNudgeBannerPromptSkipDate)) >= 2)
      )
    },
    anyValidWebSubscriptionPresent() {
      return this.paywallData?.plans?.some((p) => p.web_subscriptions?.some((ws) => [intervalPeriods.MONTH, intervalPeriods.YEAR].includes(ws.interval_period)))
    }
  },
  methods: {
    ...mapActions(useAppStateStore, ["setDesktopPaywallNudgeBannerPromptSkipDate"]),
    onClick() {
      paywallService.registerLastSource({ sourceId: this.$route.name, sourceType: paywallSourceTypes.NUDGE_BANNER })
      analytics.registerAnalyticsEvent({
        name: "desktop-paywall-nudge-banner-click",
        attributes: { route: this.$route.name }
      })

      this.$router.push({ name: this.$routes.PAYWALL })
    }
  }
}
</script>

<style lang="scss" scoped>
.corner-button {
  position: absolute !important;
  top: 8px;
  right: 8px;
}
</style>
